{
  "name": "project-name",
  "version": "1.0.76",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "build-deploy": "ng build --configuration=production"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "18.2.0",
    "@angular/cdk": "18.2.0",
    "@angular/common": "18.2.0",
    "@angular/compiler": "18.2.0",
    "@angular/core": "18.2.0",
    "@angular/forms": "18.2.0",
    "@angular/material": "18.2.0",
    "@angular/platform-browser": "18.2.0",
    "@angular/platform-browser-dynamic": "18.2.0",
    "@angular/router": "18.2.0",
    "@angular/google-maps": "18.2.0",
    "@auth0/angular-jwt": "^5.2.0",
    "@fortawesome/fontawesome-free": "^5.12.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@syncfusion/ej2-angular-inputs": "^25.1.35",
    "bootstrap": "^4.3.1",
    "howler": "^2.1.3",
    "material-design-icons": "^3.0.1",
    "ngx-cookie": "^6.0.1",
    "ngx-toastr": "^18.0.0",
    "rxjs": "~7.8.1",
    "zone.js": "0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "18.2.0",
    "@angular-eslint/builder": "18.3.1",
    "@angular-eslint/eslint-plugin": "18.3.1",
    "@angular-eslint/eslint-plugin-template": "18.3.1",
    "@angular-eslint/schematics": "18.3.1",
    "@angular-eslint/template-parser": "18.3.1",
    "@angular/cli": "18.2.0",
    "@angular/compiler-cli": "18.2.0",
    "@angular/language-service": "18.2.0",
    "@typescript-eslint/eslint-plugin": "7.18.0",
    "@typescript-eslint/parser": "7.18.0",
    "eslint": "^8.57.0",
    "sass": "^1.32.0",
    "@types/jasmine": "~5.1.4",
    "@types/node": "^20.11.0",
    "jasmine-core": "~5.1.2",
    "karma": "~6.4.3",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.2.0",
    "ts-node": "~10.9.2",
    "typescript": "5.4.5"
  }
}
